import { Link, useLocation } from "react-router-dom";
import NewsletterSignup from "@/components/NewsletterSignup";
import { Instagram, Facebook, Users } from "lucide-react";

export default function Footer() {
    const loc = useLocation();
    if (loc.pathname.startsWith("/admin")) return null;
    return (
        <footer
            data-testid="site-footer"
            className="bg-[color:var(--warm-black)] border-t border-[color:var(--espresso)] pt-20 pb-10"
        >
            <div className="mx-auto max-w-[1600px] px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
                <div className="lg:col-span-5" id="letters-from-the-table">
                    <p className="eyebrow">Stay close</p>
                    <h3 className="font-display text-4xl md:text-5xl mt-4 leading-[0.95]">
                        Letters from the <em className="text-[color:var(--gold)]">table</em>.
                    </h3>
                    <p className="mt-4 text-[color:var(--cream-muted)] max-w-md">
                        Occasional dispatches on upcoming experiences, casting, series updates, partnerships, and community news. Never more than twice a month.
                    </p>
                    <div className="mt-8">
                        <NewsletterSignup />
                    </div>
                </div>

                <div className="lg:col-span-2">
                    <p className="eyebrow">Explore</p>
                    <ul className="mt-6 space-y-3 text-sm">
                        <li><Link to="/experiences" className="link-underline">Experiences</Link></li>
                        <li><Link to="/original-series" className="link-underline">Original Series</Link></li>
                        <li><Link to="/original-series#trailer" className="link-underline">Watch the trailer</Link></li>
                        <li><Link to="/community" className="link-underline">Community</Link></li>
                        <li><Link to="/about" className="link-underline">About</Link></li>
                    </ul>
                </div>
                <div className="lg:col-span-2">
                    <p className="eyebrow">Partner</p>
                    <ul className="mt-6 space-y-3 text-sm">
                        <li><Link to="/partnerships" className="link-underline">Sponsorship</Link></li>
                        <li><Link to="/feature-your-business" className="link-underline">Feature your business</Link></li>
                        <li><Link to="/partnerships#brands" className="link-underline">Brand fit</Link></li>
                        <li><Link to="/contact" className="link-underline">Contact</Link></li>
                        <li><Link to="/admin/login" className="link-underline">Admin</Link></li>
                    </ul>
                </div>
                <div className="lg:col-span-3">
                    <p className="eyebrow">Elsewhere</p>
                    <div className="mt-6 flex gap-4 text-[color:var(--soft-cream)]">
                        <a href="https://www.instagram.com/mrs.blackinlove?utm_source=qr" target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="hover:text-[color:var(--gold)] transition-colors duration-300"><Instagram strokeWidth={1.25} /></a>
                        <a href="https://www.facebook.com/share/17pLxnBicj/?mibextid=wwXIfr" target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="hover:text-[color:var(--gold)] transition-colors duration-300"><Facebook strokeWidth={1.25} /></a>
                        <a href="https://www.facebook.com/share/g/198H5uow5s/?mibextid=wwXIfr" target="_blank" rel="noreferrer" aria-label="Private Facebook Group" data-testid="footer-fb-group" className="hover:text-[color:var(--gold)] transition-colors duration-300"><Users strokeWidth={1.25} /></a>
                    </div>
                    <a href="https://www.facebook.com/share/g/198H5uow5s/?mibextid=wwXIfr" target="_blank" rel="noreferrer" className="mt-6 inline-block link-underline text-xs uppercase tracking-[0.24em] text-[color:var(--gold)]" data-testid="footer-join-group">
                        Join our private community →
                    </a>
                    <p className="mt-8 text-xs text-[color:var(--cream-muted)] leading-relaxed">
                        <em>About the name.</em> Mrs.Black(In)Love is a play on our founding family's surname — Black. It's a love letter, not a label. This is a community for lesbian women of every background.
                    </p>
                    <p className="mt-4 text-xs text-[color:var(--cream-muted)] leading-relaxed">
                        Filming & application disclosures: Selection is at the sole discretion of the producers. No purchase required to apply.
                    </p>
                </div>
            </div>

            <div className="mx-auto max-w-[1600px] px-6 lg:px-12 mt-16 pt-8 border-t border-[color:var(--espresso)] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[color:var(--cream-muted)]">
                <p>© {new Date().getFullYear()} Mrs.Black(In)Love. All rights reserved.</p>
                <div className="flex flex-wrap gap-6">
                    <a href="#privacy" className="link-underline">Privacy</a>
                    <a href="#terms" className="link-underline">Terms</a>
                    <a href="#tickets" className="link-underline">Ticket & Refund Policy</a>
                    <a href="#disclosures" className="link-underline">Filming Disclosures</a>
                </div>
            </div>
        </footer>
    );
}
